import React from 'react';
import { documentConfig } from '../../constants/documentConfig';

const DOC_ICONS = {
  coverLetter: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7FA8" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  cv: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7FA8" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  resume: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7FA8" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  linkedin: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7FA8" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  bio: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7FA8" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  portfolio: (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7FA8" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
};

const DownloadIcon = () => (
  <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const DocumentSelector = ({
  documents,
  results,
  loading,
  allSelected,
  onSelectAll,
  onToggle,
  onStyleChange,
  onAudienceChange,
  onDownload,
}) => {
  const isDocGenerated = (docType) =>
    results?.some((r) => r.docType === docType && r.resumeText?.trim());

  return (
    <div>
      <div className="doc-select-bar">
        <span className="doc-select-label">
          {documents.filter((d) => d.selected).length} selected
        </span>
        <button
          className="select-all-btn"
          onClick={() => onSelectAll(!allSelected)}
          type="button"
        >
          {allSelected ? 'Deselect All' : 'Select All'}
        </button>
      </div>

      <div className="doc-card-grid">
        {documents.map((doc, index) => {
          const config = documentConfig[doc.type] || {};
          const isGenerated = isDocGenerated(doc.type);
          const isReady = doc.selected && isGenerated && !loading;

          return (
            <React.Fragment key={doc.type}>
              {doc.type === 'resume' && (
                <div style={{
                  gridColumn: '1 / -1',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}>
                  <span style={{
                    fontSize: '10px',
                    fontWeight: 700,
                    color: '#4A5E7A',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                  }}>Resume or CV</span>
                  <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.05)' }} />
                  <span style={{
                    fontSize: '9px',
                    color: '#2E6AFF',
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                  }}>choose one</span>
                </div>
              )}
            <div
              className={`doc-card${doc.selected ? ' doc-card--active' : ''}`}
              onClick={() => onToggle(index, !doc.selected)}
            >
              <div className="doc-card-header">
                <div className="doc-card-left">
                  <div className="doc-card-check">
                    {doc.selected && (
                      <svg className="checkmark-svg" viewBox="0 0 10 8">
                        <polyline points="1,4 4,7 9,1" />
                      </svg>
                    )}
                  </div>
                  {DOC_ICONS[doc.type]}
                  <span className="doc-card-label">{config.label}</span>
                </div>

                <button
                  type="button"
                  className="doc-card-dl-btn"
                  disabled={!isReady}
                  title={isReady ? `Download ${config.label}` : 'Generate first'}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDownload('docx');
                  }}
                >
                  <DownloadIcon />
                </button>
              </div>

              {doc.selected && (
                <div
                  className="doc-card-options"
                  onClick={(e) => e.stopPropagation()}
                >
                  <select
                    className="input"
                    value={doc.style}
                    onChange={(e) => onStyleChange(index, e.target.value)}
                  >
                    {config.styles.map((style) => (
                      <option key={style} value={style}>
                        {style}
                      </option>
                    ))}
                  </select>
                  <select
                    className="input"
                    value={doc.audience}
                    onChange={(e) => onAudienceChange(index, e.target.value)}
                  >
                    <option value="ATS / Human">ATS / Human</option>
                    <option value="ATS Only">ATS Only</option>
                    <option value="Human Only">Human Only</option>
                  </select>
                </div>
              )}
            </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentSelector;
